/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NbWindowService} from '@nebular/theme';
import {BaseComponent, FileService} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';

@Component({
  selector: 'app-dam-item-version-rename',
  templateUrl: './dam-item-versions-rename.component.html',
  styleUrls: ['./dam-item-versions-rename.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamItemVersionsRenameComponent extends BaseComponent implements OnInit {

  constructor(protected readonly fileService: FileService,
              protected readonly windowService: NbWindowService) {
    super();
  }

  @Input()
  damItemVersionId: number;

  @Input()
  damItemVersionHeader: string;

  fileExt = '';

  form = new FormGroup({header: new FormControl('', [Validators.required])});

  ngOnInit(): void {
    let fileName = this.damItemVersionHeader.match(/([\w,\s-]+)\.[A-Za-z]{3}/)[1];
    this.fileExt = this.damItemVersionHeader.slice(fileName.length, this.damItemVersionHeader.length);
    this.form = new FormGroup({
      header: new FormControl(fileName, [Validators.required])
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.compoApiService.post('/dam/rename-version/' + this.damItemVersionId, {
        header: this.form.controls['header'].value + this.fileExt
      }).pipe(take(1), catchError(err => this.handleError(err))).subscribe(() => this.successToast(translations.successfully));
    }
  }

}
